<script>
import entreprise from '../../../assets/icons/ic-entreprise.svg'
import { updateService } from "@/component/cdevs/allFunctions";
import ic_deletePopup from "@/assets/icons/ic_deletePopup.svg";

export default {
  name: 'AffectationPopup',
    components:{
      // VueSvgIcon,
    },
  data() {
    return {
      icons: {ic_deletePopup},
    };
  },
  emit: ['closeDelete', 'refresh'], 
  props: {
    showPopup2: {
      type: Boolean,
      required: true,
    },
     serviceId: {
      type: String,
      required: true
    }
  },
  
methods: {
    async desactiveService() {
        console.log('serviceId:', this.serviceId); // Ajoute ce log

      if (this.name === '' || this.description === '' || this.email === '') {
        return this.$toast.error('Veuillez remplir tous les champs')
      }
      this.charge = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        isActive: false,
        id: this.serviceId
      }
      await updateService(data).then(response => {
        console.log(response)
        this.charge = false;
        this.$toast.success('Service masqué avec succès');
        this.$emit('refresh');
        this.$emit('closeDelete', true);
      }).catch(error => {
        console.log(error)
        this.charge = false;
        this.$toast.error('Une erreur est survenue');
      })
    },
  },
}
</script>

<template>
  <div
    class="popup-overlay"
  >
    <div class="popup-content bg-white w-1/3 py-5 relative">
      <div class="flex font-c7 text-c24 px-5">
        Suppression
      </div>
      <div class="mt-10">
        <icon
          :data="icons.ic_deletePopup"
          height="122"
          width="122"
          class="w-5 h-5"
          original
        />
        <div class="w-3/5 mx-auto mt-3">
          Supprimer ce service entraînera la perte de toutes les données associées dans ce fichier.
        </div>
      </div>
      <div class="mt-5">
        <div class="flex justify-end items-center mt-5 mx-5">
          <div
            class="font-c5 text-red-500 mt-2 text-sm ml-5 cursor-pointer annulerr px-7 py-3 rounded-8"
            @click="$emit('closeDelete', false)"
          >
            Annuler
          </div>
          <div
            class="text-red-500 mt-2 text-sm ml-5 cursor-pointer save px-20 py-3 rounded-8 text-white "
            @click="desactiveService"
          >
            suppirmer
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.annulerr{
    background-color: #EFF4FB;
}
.save{
    background-color: #F35D49;
}
.colorBorderB{
    border-bottom: 3px solid #E7EEF8;
}
.bgInpout{
    /* background-color: #F0F2F7; */
    border: 1px solid #F0F2F7
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popup-content {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 25rem;
}
.relative {
  position: relative;
}
</style>
